/**
 * atb-recently-viewed-tracker.js
 * --------------------------------------------------------------------------
 * Global tracker, loaded on every page via theme.liquid. Detects PDPs and
 * appends the current product handle to a localStorage list that the
 * <atb-recently-viewed> section reads back to render the carousel.
 *
 * Storage shape:
 *   localStorage["atb_recently_viewed"] = JSON.stringify([
 *     { handle: "neon-vibe",      viewed_at: 1716480000000 },
 *     { handle: "silicone-cuffs", viewed_at: 1716479800000 },
 *     ...
 *   ])
 *
 * Persistence:
 *   - localStorage is origin-scoped → persists across tabs/sessions/restarts
 *   - Cleared only on: customer clearing browser data, incognito close,
 *     storage quota exceeded (won't happen at <5KB)
 *
 * Buffer beyond the carousel cap (carousel shows 4):
 *   The tracker stores up to 8 entries so that if the renderer's
 *   availability/freshness filter trims items, there's a backlog to fall
 *   back on.
 *
 * Self-contained IIFE — no globals, no dependencies.
 */
(function () {
  'use strict';

  // Match /products/<handle> with optional trailing slash or query/hash.
  // Works regardless of locale prefix (/en-ca/products/...).
  const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!match) return;

  const handle = match[1];
  if (!handle) return;

  const STORAGE_KEY = 'atb_recently_viewed';
  const MAX_BUFFER = 8;

  let list = [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) list = parsed;
    }
  } catch (_) {
    list = [];
  }

  // De-dupe by handle, prepend new entry at the front so MRU comes first.
  list = list.filter((item) => item && item.handle && item.handle !== handle);
  list.unshift({ handle: handle, viewed_at: Date.now() });
  if (list.length > MAX_BUFFER) list = list.slice(0, MAX_BUFFER);

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (_) {
    // localStorage disabled (Safari private mode pre-iOS 16, quota full,
    // etc.) — silently no-op. The carousel simply won't have data to
    // render for this customer.
  }
})();
